// import './Flashcard.css';
import React, {
  useCallback,
  useEffect,
  useRef,
  useReducer,
  useState,
} from 'react';
import { Button, Snackbar, Checkbox, FormControlLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector, useStore } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Alert from '@material-ui/lab/Alert';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import AuthService from '../..//api/auth.service';

import {
  deleteFlashcard,
  getAllFlashcardHeaders,
  getFlashcardBody,
  updateFlashcardHeader,
} from '../../actions/flashcards';
import { createTest } from '../../actions/tests';

import { getTrainings } from '../../actions/trainings';

import TestformGeneric from './Testforms/TestformGeneric';

import { getFlashcardTypes } from '../../actions/flashcardTypes';

import { testIntervals } from '../Flashcards/Flashcardselection';
import { testIntervalsInSecs } from '../Flashcards/Flashcardselection';
import { LatexEditorFormContext } from '../common/LatexEditorFormContext';
import Flashcardform from '../Flashcards/Flashcardform/Flashcardform';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
    },
  },
  paper: {
    padding: theme.spacing(2),
  },
  form: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  fileInput: {
    width: '97%',
    margin: '10px 0',
  },
  buttonSubmit: {
    margin: 10,
  },
  buttonClear: {
    margin: 10,
  },
}));

export const calcAchivement = (newPasslevel, oldPasslevel) => {
  if (
    newPasslevel >= testIntervalsInSecs.length ||
    oldPasslevel >= testIntervalsInSecs.length
  ) {
    console.warn('wrong passlevel used to calculate achievement');
    return 0;
  }

  return Math.round(
    (testIntervalsInSecs[newPasslevel] - testIntervalsInSecs[oldPasslevel]) /
      86400,
  );
};

/** MongoDB IDs may be strings or objects — normalize for comparison. */
const idKey = (id) => (id == null ? '' : String(id));

const addUnsolvedId = (ids, id) => {
  const k = idKey(id);
  if (!k) return ids;
  if (ids.some((x) => idKey(x) === k)) return ids;
  return [...ids, k];
};

const removeUnsolvedId = (ids, id) => {
  const k = idKey(id);
  if (!k) return ids;
  return ids.filter((x) => idKey(x) !== k);
};

const shuffleIndices = (n) => {
  const remapping = Array.from({ length: n }, (_, i) => i);
  return remapping.sort(() => Math.random() - 0.5);
};

/** Next round uses only sessionUnsolvedIds (manual or automatic). */
const buildRepeatRoundPayload = (sessionUnsolvedIds, flashcardHeaders) => {
  const ids = [...new Set((sessionUnsolvedIds || []).map(idKey))];
  const cards = ids
    .map((sid) => flashcardHeaders.find((h) => idKey(h._id) === sid))
    .filter(Boolean);
  if (cards.length === 0) return null;
  const remapping = shuffleIndices(cards.length);
  return {
    remappingState: remapping,
    flashcardTests: cards,
    currentTest: 0,
    flashcardDataHeader: cards[remapping[0]],
  };
};

const testStatusReducer = (state, action) => {
  let newState = state;
  switch (action.type) {
    case 'SOLVE':
      if (state.solved === 'correcting') {
        if (state.formref.current.solve()) {
          newState.solved = 'corrected';
          // Do not remove from sessionUnsolvedIds: answer was wrong → card should appear in the repeat round.
        }
        newState.openAlert = true;
        newState.solution = state.formref.current.solution();
        newState.solutionInfo = state.formref.current.solutionInfo();
      } else if (state.solved === 'open') {
        if (state.formref.current.solve()) {
          newState.numPassedTests = state.numPassedTests + 1;
          newState.solved = 'solved';
          newState.sessionUnsolvedIds = removeUnsolvedId(
            state.sessionUnsolvedIds,
            state.flashcardData._id,
          );
          let header = JSON.parse(JSON.stringify(state.flashcardData.header));
          header.lastpass = new Date().toISOString();
          header.passlevel = Math.min(
            state.flashcardData.header.passlevel + 1,
            testIntervals.length - 1,
          );
          newState.flashcardDataHeader = header;
          newState.flashcardData.header = header;
        } else {
          newState.numFailedTests = state.numFailedTests + 1;
          newState.solved = 'correcting';
          newState.sessionUnsolvedIds = addUnsolvedId(
            state.sessionUnsolvedIds,
            state.flashcardData._id,
          );
          let header = JSON.parse(JSON.stringify(state.flashcardData.header));
          header.lastpass = new Date().toISOString();
          header.passlevel = 0;
          newState.flashcardDataHeader = header;
          newState.flashcardData.header = header;
        }
        newState.openAlert = true;
        newState.solution = state.formref.current.solution();
        newState.solutionInfo = state.formref.current.solutionInfo();
      } else {
        newState.currentTest = state.currentTest + 1;
        if (!state.solved) {
          newState.flashcardData.header.lastpass = '';
          newState.flashcardData.header.passlevel = 0;
        }
        if (newState.currentTest < state.flashcardTests.length) {
          newState.achievement =
            state.achievement +
            calcAchivement(
              state.flashcardData.header.passlevel,
              state.oldPasslevel,
            );
        }
        newState.openAlert = false;
        newState.solved = 'open';
        newState.lastAction = 'solved';
      }
      return {
        ...newState,
      };
    case 'SKIP':
      if (state.solved !== 'open') {
        let header = JSON.parse(JSON.stringify(state.flashcardData.header));
        header.lastpass = state.oldLastPass;
        header.passlevel = state.oldPasslevel;
        newState.flashcardDataHeader = header;
        newState.flashcardData.header = header;
        newState.numPassedTests = state.oldNumPassedTests;
        newState.numFailedTests = state.oldNumFailedTests;
      }
      newState.numSkippedTests = state.numSkippedTests + 1;
      newState.sessionUnsolvedIds = addUnsolvedId(
        state.sessionUnsolvedIds,
        state.flashcardData._id,
      );
      newState.currentTest = state.currentTest + 1;
      newState.solved = 'open';
      newState.openAlert = false;
      newState.lastAction = 'skipped';
      return {
        ...newState,
      };
    case 'ACCEPT':
      if (state.solved !== 'solved') {
        newState.numPassedTests = state.numPassedTests + 1;
      }
      newState.numFailedTests = state.oldNumFailedTests;

      let header = JSON.parse(JSON.stringify(state.flashcardData.header));
      header.lastpass = new Date().toISOString();
      header.passlevel = Math.min(state.oldPasslevel + 1, testIntervals.length);
      newState.flashcardDataHeader = header;
      newState.flashcardData.header = header;
      newState.solved = 'solved';
      newState.sessionUnsolvedIds = removeUnsolvedId(
        state.sessionUnsolvedIds,
        state.flashcardData._id,
      );
      newState.openAlert = true;
      newState.solution = state.formref.current.solution();
      newState.solutionInfo = state.formref.current.solutionInfo();
      newState.lastAction = 'accepted';
      return {
        ...newState,
      };
    case 'UPDATE_FLASHCARD_BODY':
      return {
        ...state,
        oldPasslevel: action.payload.oldPasslevel,
        oldLastPass: action.payload.oldLastPass,
        oldNumPassedTests: state.numPassedTests,
        oldNumFailedTests: state.numFailedTests,
        flashcardData: { ...action.payload.flashcardData },
        // Must stay in sync with flashcardData — otherwise updateFlashcardHeader persists wrong headers (e.g. wrong trainings).
        flashcardDataHeader: action.payload.flashcardData.header,
      };
    case 'PREPARE_NEXT_CARD': {
      const card = action.payload.card;
      const header = JSON.parse(JSON.stringify(card.header));
      return {
        ...state,
        flashcardData: {
          header,
          _id: card._id,
          source: undefined,
        },
        flashcardDataHeader: header,
        oldPasslevel: header.passlevel,
        oldLastPass: header.lastpass,
        solved: 'open',
        openAlert: false,
      };
    }
    case 'INITIALIZE_FLASHCARDS':
      if (
        !action.payload.flashcardTests?.length ||
        !action.payload.flashcardDataHeader
      ) {
        return {
          ...state,
          flashcardTests: [],
          remappingState: action.payload.remappingState ?? [],
          currentTest: 0,
          sessionUnsolvedIds: [],
          flashcardData: null,
          flashcardDataHeader: null,
        };
      }
      {
        const card = action.payload.flashcardDataHeader;
        const header = JSON.parse(JSON.stringify(card.header));
        return {
          ...state,
          flashcardData: {
            header,
            _id: card._id,
            source: undefined,
          },
          flashcardDataHeader: header,
          remappingState: action.payload.remappingState,
          flashcardTests: action.payload.flashcardTests,
          currentTest: action.payload.currentTest,
          sessionUnsolvedIds: [],
        };
      }
    case 'REPEAT_ROUND': {
      const card = action.payload.flashcardDataHeader;
      const header = JSON.parse(JSON.stringify(card.header));
      return {
        ...state,
        flashcardData: {
          header,
          _id: card._id,
          source: undefined,
        },
        flashcardDataHeader: header,
        oldPasslevel: header.passlevel,
        oldLastPass: header.lastpass,
        remappingState: action.payload.remappingState,
        flashcardTests: action.payload.flashcardTests,
        currentTest: action.payload.currentTest,
        sessionUnsolvedIds: [],
        solved: 'open',
        openAlert: false,
        numPassedTests: 0,
        numFailedTests: 0,
        numSkippedTests: 0,
        lastAction: '',
        roundNumber: (state.roundNumber || 0) + 1,
      };
    }
    case 'CLEAR_STUCK_UNSOLVED':
      return {
        ...state,
        sessionUnsolvedIds: [],
      };
    case 'FINISH_REPEAT_SESSION':
      return {
        ...state,
        flashcardTests: [],
        remappingState: [],
        currentTest: 0,
        sessionUnsolvedIds: [],
        flashcardData: null,
        flashcardDataHeader: null,
        solved: 'open',
        openAlert: false,
      };
    case 'UNSET_OPEN_ALERT':
      return {
        ...state,
        openAlert: false,
      };

    case 'DELETE_CURRENT_FROM_SESSION': {
      const deletedId = action.payload.deletedId;
      const { flashcardTests, remappingState, currentTest, sessionUnsolvedIds } =
        state;
      const n = flashcardTests.length;
      if (n === 0) return state;
      const ftIdx = remappingState[currentTest];
      if (ftIdx === undefined) return state;
      const currentId = flashcardTests[ftIdx]?._id;
      if (idKey(currentId) !== idKey(deletedId)) return state;

      const ordered = [];
      for (let k = 0; k < n; k++) {
        if (k === currentTest) continue;
        ordered.push(flashcardTests[remappingState[k]]);
      }

      const newSessionUnsolved = removeUnsolvedId(sessionUnsolvedIds, deletedId);
      const newRemapping = ordered.map((_, i) => i);

      if (ordered.length === 0) {
        return {
          ...state,
          flashcardTests: [],
          remappingState: [],
          currentTest: 0,
          sessionUnsolvedIds: newSessionUnsolved,
          flashcardData: null,
          flashcardDataHeader: null,
          solved: 'open',
          openAlert: false,
          lastAction: 'deleted',
        };
      }

      const newCurrentTest = currentTest;
      if (newCurrentTest >= ordered.length) {
        return {
          ...state,
          flashcardTests: ordered,
          remappingState: newRemapping,
          currentTest: ordered.length,
          sessionUnsolvedIds: newSessionUnsolved,
          flashcardData: null,
          flashcardDataHeader: null,
          solved: 'open',
          openAlert: false,
          lastAction: 'deleted',
        };
      }

      const card = ordered[newCurrentTest];
      const header = JSON.parse(JSON.stringify(card.header));
      return {
        ...state,
        flashcardTests: ordered,
        remappingState: newRemapping,
        currentTest: newCurrentTest,
        sessionUnsolvedIds: newSessionUnsolved,
        flashcardData: {
          header,
          _id: card._id,
          source: undefined,
        },
        flashcardDataHeader: header,
        oldPasslevel: header.passlevel,
        oldLastPass: header.lastpass,
        solved: 'open',
        openAlert: false,
        lastAction: 'deleted',
      };
    }

    default:
      throw new Error();
  }
};

const upForTest = (card) => {
  if (!card.header.active) {
    return false;
  }
  const secondsSinceLastPass =
    (Date.parse(new Date().toISOString()) - Date.parse(card.header.lastpass)) /
    1000.0;

  if (card.header.passlevel == 0) {
    return true;
  } else if (
    secondsSinceLastPass > testIntervalsInSecs[card.header.passlevel]
  ) {
    return true;
  } else {
    return false;
  }
};

const DEFAULT_MAX_FLASHCARDS_TRAIN_ALL = 30;

const Testform = ({
  close,
  training,
  maxFlashcardsPerTrainingSession = DEFAULT_MAX_FLASHCARDS_TRAIN_ALL,
}) => {
  const classes = useStyles();
  const store = useStore();
  const trainings = useSelector((state) => state.trainings);
  const flashcardHeaders = useSelector((state) => state.flashcardHeaders);
  const flashcardTypesFromDb = useSelector((state) => state.flashcardTypes);

  const [testStatus, dispatchTestStatus] = useReducer(testStatusReducer, {
    remappingState: [],
    currentTest: -1,
    oldPasslevel: 0,
    oldLastPass: '',
    openAlert: false,
    solved: 'open', // open | solved | correcting | corrected
    solution: '',
    solutionInfo: '',
    numPassedTests: 0,
    numFailedTests: 0,
    numSkippedTests: 0,
    oldNumPassedTests: 0,
    oldNumFailedTests: 0,
    achievement: 0,
    formref: useRef(),
    flashcardData: null,
    flashcardDataHeader: null,
    flashcardTests: [],
    activatedFlashcardHeaders: 0,
    possibleAchievement: 0,
    lastAction: '',
    sessionUnsolvedIds: [],
    roundNumber: 0,
  });

  const [started, setStarted] = useState(false);
  const [currentUser, setCurrentUser] = useState(undefined);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [deleteErrorOpen, setDeleteErrorOpen] = useState(false);
  const [useLatex, setUseLatex] = useState(false);
  const [editFlashcardOpen, setEditFlashcardOpen] = useState(false);
  const [editFlashcardId, setEditFlashcardId] = useState(null);
  /** Prevents rebuilding the card pool on every Redux header update (otherwise solved cards reappear). */
  const trainingPoolInitDoneRef = useRef(false);

  useEffect(() => {
    const user = AuthService.getCurrentUser();

    if (user) {
      setCurrentUser(user);
    }
  }, []);

  useEffect(() => {
    if (
      testStatus.flashcardData == null ||
      testStatus.flashcardData._id === undefined ||
      testStatus.flashcardData.header == null
    ) {
      return;
    }
    dispatch(
      updateFlashcardHeader(testStatus.flashcardData._id, {
        header: testStatus.flashcardData.header,
      }),
    );
  }, [testStatus.flashcardDataHeader]);

  useEffect(() => {
    // Keep trainings bounded: when a user comes back after long inactivity,
    // a lot of cards can become "up for test". We only take the newest ones.
    // Wait until Redux has data; initialize only once (not on every header update after solved cards).
    if (trainingPoolInitDoneRef.current) {
      return;
    }
    if (!flashcardHeaders?.length || !trainings?.length) {
      return;
    }

    const getFlashcardCreatedMs = (card) => {
      const created = card?.header?.created;
      const lastUpdated = card?.header?.lastupdated;

      // `Date.parse('')` yields NaN; `|| 0` turns NaN into 0.
      return (
        Date.parse(created || '') ||
        Date.parse(lastUpdated || '') ||
        0
      );
    };

    const cardInTrainingIds = (flashcardIds, cardId) =>
      (flashcardIds ?? []).some((fid) => idKey(fid) === idKey(cardId));

    const flashcardTests = flashcardHeaders.filter((card) => {
      if (training === undefined || training === '') {
        const ids = trainings
          .map((t) => {
            if (t.active) {
              return t.flashcardIds;
            }
          })
          .flat();
        return cardInTrainingIds(ids, card._id) && upForTest(card);
      } else {
        const ids = trainings
          .map((item) => {
            if (training === item.name && item.active) return item.flashcardIds;
          })
          .flat();
        return cardInTrainingIds(ids, card._id) && upForTest(card);
      }
    });

    // Take newest testable cards only, then randomize order.
    const flashcardTestsNewestFirst = [...flashcardTests].sort(
      (a, b) => getFlashcardCreatedMs(b) - getFlashcardCreatedMs(a),
    );
    const sessionLimit =
      maxFlashcardsPerTrainingSession === 'all'
        ? flashcardTestsNewestFirst.length
        : maxFlashcardsPerTrainingSession;
    const limitedFlashcardTests = flashcardTestsNewestFirst.slice(
      0,
      sessionLimit,
    );

    trainingPoolInitDoneRef.current = true;

    let remapping = [];
    remapping.length = limitedFlashcardTests.length;

    for (var i = 0; i < remapping.length; i++) {
      remapping[i] = i;
    }
    remapping = remapping.sort(() => Math.random() - 0.5);

    const firstCard =
      limitedFlashcardTests.length > 0
        ? limitedFlashcardTests[remapping[0]]
        : null;

    dispatchTestStatus({
      type: 'INITIALIZE_FLASHCARDS',
      payload: {
        remappingState: remapping,
        flashcardTests: limitedFlashcardTests,
        currentTest: 0,
        flashcardDataHeader: firstCard,
      },
    });
  }, [flashcardHeaders, trainings, training, maxFlashcardsPerTrainingSession]);

  const flashcardBody = useSelector((state) => state.flashcardBody);
  // Guards against out-of-order async responses from `getFlashcardBody()`.
  // Without this, an earlier request can overwrite `flashcardData` for the
  // currently active test card.
  const expectedFlashcardBodyIdRef = useRef(null);

  useEffect(() => {
    if (flashcardBody.source === undefined) {
      return;
    }
    // Ignore stale responses (can happen when user advances quickly).
    if (
      expectedFlashcardBodyIdRef.current !== null &&
      flashcardBody._id !== expectedFlashcardBodyIdRef.current
    ) {
      return;
    }
    let pos = -1;
    for (let i = 0; i < flashcardHeaders.length; i++) {
      if (idKey(flashcardHeaders[i]._id) === idKey(flashcardBody._id)) {
        pos = i;
      }
    }
    if (pos >= 0) {
      dispatchTestStatus({
        type: 'UPDATE_FLASHCARD_BODY',
        payload: {
          oldPasslevel: flashcardHeaders[pos].header.passlevel,
          oldLastPass: flashcardHeaders[pos].header.lastpass,
          flashcardData: {
            header: flashcardHeaders[pos].header,
            ...flashcardBody,
          },
        },
      });
    }
  }, [flashcardBody]);

  const dispatch = useDispatch();

  const handleCloseEditFlashcard = useCallback(async () => {
    const id = editFlashcardId;
    await dispatch(getAllFlashcardHeaders());
    setEditFlashcardOpen(false);
    setEditFlashcardId(null);
    if (!id) return;
    const headers = store.getState().flashcardHeaders;
    const exists = headers.some((h) => idKey(h._id) === idKey(id));
    if (exists) {
      expectedFlashcardBodyIdRef.current = id;
      dispatch(getFlashcardBody(id));
    } else {
      dispatchTestStatus({
        type: 'DELETE_CURRENT_FROM_SESSION',
        payload: { deletedId: id },
      });
    }
  }, [dispatch, store, editFlashcardId, dispatchTestStatus]);

  const openEditFlashcard = useCallback(() => {
    const id = testStatus.flashcardData?._id;
    if (!id) return;
    setEditFlashcardId(id);
    setEditFlashcardOpen(true);
  }, [testStatus.flashcardData?._id]);

  useEffect(() => {
    dispatch(getAllFlashcardHeaders());
    dispatch(getTrainings());
    dispatch(getFlashcardTypes());
  }, []);

  const sessionCurrentCardId =
    testStatus.flashcardTests?.[testStatus.remappingState?.[testStatus.currentTest]]
      ?._id;

  useEffect(() => {
    if (testStatus.flashcardDataHeader !== null) {
      if (
        started &&
        testStatus.lastAction !== 'skipped' &&
        testStatus.lastAction !== 'deleted'
      ) {
        dispatch(
          createTest({
            tester: currentUser.username,
            flashcardid: testStatus.flashcardData._id,
            conductiondate: new Date().toISOString(),
            oldpasslevel: testStatus.oldPasslevel,
            newpasslevel: testStatus.flashcardData.header.passlevel,
          }),
        );
      }
      setStarted(true);
    }
    const currentCard =
      testStatus.flashcardTests?.[testStatus.remappingState?.[testStatus.currentTest]];
    if (currentCard !== undefined) {
      expectedFlashcardBodyIdRef.current = currentCard._id;
      // Clear local card first (no solutions from the previous card), then load body.
      dispatchTestStatus({
        type: 'PREPARE_NEXT_CARD',
        payload: { card: currentCard },
      });
      dispatch(getFlashcardBody(currentCard._id));
    }
  }, [testStatus.currentTest, sessionCurrentCardId, testStatus.roundNumber]);

  const solve = () => {
    dispatchTestStatus({ type: 'SOLVE' });
  };

  const restartWithUnsolved = useCallback(() => {
    const payload = buildRepeatRoundPayload(
      testStatus.sessionUnsolvedIds,
      flashcardHeaders,
    );
    if (!payload) return;
    dispatchTestStatus({ type: 'REPEAT_ROUND', payload });
  }, [testStatus.sessionUnsolvedIds, flashcardHeaders]);

  let activatedFlashcardHeaders = [];
  let possibleAchievement = 0;
  if (testStatus.flashcardTests.length > 0) {
    if (trainings.length > 0) {
      activatedFlashcardHeaders = testStatus.flashcardTests.filter(
        (flashcard, index) => {
          return (
            trainings.some(
              (training) =>
                flashcard.header.trainings.includes(training.name) &&
                training.active,
            ) &&
            !testStatus.remappingState
              .slice(0, testStatus.currentTest)
              .includes(index)
          );
        },
      );
    }
    if (activatedFlashcardHeaders.length > 0) {
      possibleAchievement = activatedFlashcardHeaders
        .map((entry) => {
          let result = 0;
          if (entry.header.passlevel >= testIntervalsInSecs.length) {
            result = testIntervalsInSecs[testIntervalsInSecs.length - 1];
          } else {
            result = testIntervalsInSecs[entry.header.passlevel];
          }
          return (result + (entry.header.passlevel !== 0 ? 14400 : 0)) / 86400;
        })
        .reduce((x, y) => {
          return x + y;
        });
    }
  }

  const skip = () => {
    dispatchTestStatus({ type: 'SKIP' });
  };

  const acceptAnyway = () => {
    dispatchTestStatus({ type: 'ACCEPT' });
  };

  const confirmDeleteCurrentCard = async () => {
    const id = testStatus.flashcardData?._id;
    if (!id) {
      setDeleteConfirmOpen(false);
      return;
    }
    const ok = await dispatch(deleteFlashcard(id));
    setDeleteConfirmOpen(false);
    if (ok) {
      dispatch(getTrainings());
      dispatchTestStatus({
        type: 'DELETE_CURRENT_FROM_SESSION',
        payload: { deletedId: id },
      });
    } else {
      setDeleteErrorOpen(true);
    }
  };

  const len = testStatus.flashcardTests.length;
  const hasUnsolved = (testStatus.sessionUnsolvedIds?.length ?? 0) > 0;
  /** Show "Again" when the round is over / last card finished — not while correcting (still wrong). */
  const lastCardRoundDone =
    testStatus.currentTest === len - 1 &&
    (testStatus.solved === 'solved' || testStatus.solved === 'corrected');

  const showRestartUnsolved =
    hasUnsolved &&
    len > 0 &&
    (testStatus.currentTest === len || lastCardRoundDone);

  /** Interstitial: hide card UI until the user starts the repeat round. */
  const hideCardForRepeatPrompt =
    showRestartUnsolved &&
    (lastCardRoundDone || testStatus.currentTest === len);

  const showPrimaryButton =
    showRestartUnsolved || testStatus.currentTest < len;

  useEffect(() => {
    if (!showRestartUnsolved) {
      return;
    }
    const onKeyDown = (e) => {
      if (
        (e.code === 'Enter' || e.code === 'NumpadEnter') &&
        e.ctrlKey &&
        !e.shiftKey &&
        !e.altKey
      ) {
        e.preventDefault();
        restartWithUnsolved();
      }
    };
    window.addEventListener('keydown', onKeyDown, true);
    return () => window.removeEventListener('keydown', onKeyDown, true);
  }, [showRestartUnsolved, restartWithUnsolved]);

  /**
   * Ctrl+ö / Ctrl+ü must work from any focus (dropdown, quiz checkboxes, image
   * tasks, etc.). Field-level onKeyPress often misses Ctrl combos or never
   * fires; capture-phase keydown also prevents browser/OS defaults that can
   * feel like the session "closing".
   */
  useEffect(() => {
    if (editFlashcardOpen || deleteConfirmOpen) {
      return;
    }
    const trainingActive =
      testStatus.flashcardData != null &&
      testStatus.flashcardTests.length > 0;
    const skipShortcutEnabled =
      trainingActive && showPrimaryButton && !hideCardForRepeatPrompt;
    /** Accept anyway: wrong answer, correction flow, or force-pass while still answering. */
    const acceptShortcutEnabled =
      trainingActive &&
      showPrimaryButton &&
      !hideCardForRepeatPrompt &&
      testStatus.flashcardData?.source !== undefined &&
      testStatus.solved !== 'solved' &&
      (testStatus.solved === 'open' ||
        testStatus.solved === 'correcting' ||
        testStatus.solved === 'corrected' ||
        testStatus.solved === 'error');

    if (!skipShortcutEnabled && !acceptShortcutEnabled) {
      return;
    }

    const onKeyDown = (e) => {
      if (!e.ctrlKey || e.metaKey || e.altKey || e.shiftKey) {
        return;
      }
      const k = e.key;
      if (skipShortcutEnabled && (k === 'ö' || k === 'Ö')) {
        e.preventDefault();
        e.stopPropagation();
        dispatchTestStatus({ type: 'SKIP' });
        return;
      }
      // German QWERTZ: Ctrl+ü often keeps code BracketRight but key is not "ü".
      const ctrlUe =
        k === 'ü' ||
        k === 'Ü' ||
        (e.code === 'BracketRight' && k !== ']' && k !== '}');
      if (acceptShortcutEnabled && ctrlUe) {
        e.preventDefault();
        e.stopPropagation();
        dispatchTestStatus({ type: 'ACCEPT' });
      }
    };

    window.addEventListener('keydown', onKeyDown, true);
    return () => window.removeEventListener('keydown', onKeyDown, true);
  }, [
    editFlashcardOpen,
    deleteConfirmOpen,
    testStatus.flashcardData,
    testStatus.flashcardTests.length,
    testStatus.solved,
    showPrimaryButton,
    hideCardForRepeatPrompt,
  ]);

  const matchingFlashcardType = (flashcardTypesFromDb || []).find(
    (t) => t.name === testStatus.flashcardData?.header?.type,
  );

  let test;
  if (
    testStatus.flashcardData !== null &&
    testStatus.flashcardData.header !== undefined &&
    testStatus.flashcardData.source !== undefined
  ) {
    if (matchingFlashcardType) {
      test = (
        <TestformGeneric
          ref={testStatus.formref}
          flashcardData={testStatus.flashcardData}
          flashcardType={matchingFlashcardType}
          submit={solve}
          allowCtrlEnterSubmit={showPrimaryButton}
        />
      );
    } else {
      test = (
        <div>
          Flashcard type &ldquo;{testStatus.flashcardData.header.type}&rdquo;
          not found. Please ensure card types are loaded.
        </div>
      );
    }
  }

  const acceptAnywayButton = (
    <Button onClick={acceptAnyway}>{`>>> Accept anyway <<<`}</Button>
  );

  const hideButton = (
    <Button
      onClick={() => {
        dispatchTestStatus({ type: 'UNSET_OPEN_ALERT' });
      }}
    >{`(hide)`}</Button>
  );

  let alertMessage;

  switch (testStatus.solved) {
    default:
    case 'solved':
      alertMessage = (
        <Alert severity="success">
          Solved flashcard! {testStatus.solutionInfo}
          <Button
            onClick={() => {
              dispatchTestStatus({ type: 'UNSET_OPEN_ALERT' });
            }}
          >{`(hide)`}</Button>
        </Alert>
      );
      break;
    case 'corrected':
      alertMessage = (
        <Alert severity="warning">
          Corrected answer! {testStatus.solutionInfo}
          {acceptAnywayButton}
          {hideButton}
        </Alert>
      );
      break;
    case 'correcting':
    case 'error':
      alertMessage = (
        <Alert severity="error">
          Filled in incorrectly! Correct answer:
          {testStatus.solution}
          {testStatus.solutionInfo}
          {acceptAnywayButton}
          {hideButton}
        </Alert>
      );
  }

  let logo = '';
  if (
    testStatus.flashcardData !== null &&
    testStatus.flashcardData.header.trainings !== undefined &&
    testStatus.flashcardData.header.trainings.length > 0
  ) {
    const matchedTraining = trainings.find(
      (training) =>
        training.name === testStatus.flashcardData.header.trainings[0],
    );
    logo = matchedTraining?.logo ?? '';
  }

  return (
    <div>
      {editFlashcardOpen && editFlashcardId != null ? (
        <Flashcardform
          key={String(editFlashcardId)}
          flashcardHeaders={flashcardHeaders}
          currentId={editFlashcardId}
          close={handleCloseEditFlashcard}
        />
      ) : null}
      <Snackbar open={testStatus.openAlert}>{alertMessage}</Snackbar>
      <Snackbar
        open={deleteErrorOpen}
        autoHideDuration={6000}
        onClose={() => setDeleteErrorOpen(false)}
      >
        <Alert severity="error" onClose={() => setDeleteErrorOpen(false)}>
          The card could not be deleted.
        </Alert>
      </Snackbar>
      <Dialog
        open={deleteConfirmOpen}
        onClose={() => setDeleteConfirmOpen(false)}
      >
        <DialogTitle>Delete card?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Permanently delete the flashcard &ldquo;
            {testStatus.flashcardData?.header?.title ?? ''}
            &rdquo;? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteConfirmOpen(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={confirmDeleteCurrentCard} color="secondary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      {testStatus.flashcardData != null &&
      testStatus.flashcardData.header !== undefined &&
      testStatus.flashcardTests.length > 0 ? (
        <Dialog open>
          <DialogTitle id="simple-dialog-title">
            Flashcard {testStatus.flashcardData.header.type}:{' '}
            {testStatus.flashcardData.header.trainings}
            {'      '}
            {logo !== '' ? (
              <img
                src={logo}
                height="40"
                style={{ border: '0px solid rgba(0, 0, 0, 1.0)' }}
              />
            ) : (
              <></>
            )}
          </DialogTitle>
          {/* https://codesandbox.io/s/xr292j5oq4?file=/src/index.js:312-379 */}
          <Grid container direction="row" style={{ margin: 0 }}>
            <Grid item>
              Solve flashcard - Level{' '}
              {testStatus.solved === 'open'
                ? `${testStatus.flashcardData.header.passlevel} (${
                    testIntervals[testStatus.flashcardData.header.passlevel]
                  })`
                : `${testStatus.oldPasslevel} (${
                    testIntervals[testStatus.oldPasslevel]
                  }) -> ${testStatus.flashcardData.header.passlevel} (${
                    testIntervals[testStatus.flashcardData.header.passlevel]
                  })`}{' '}
              :
            </Grid>
          </Grid>
          <FormControlLabel
            control={
              <Checkbox
                checked={useLatex}
                onChange={(e) => setUseLatex(e.target.checked)}
                color="primary"
                inputProps={{
                  'aria-label':
                    'Use LaTeX: show math toolbar, symbol palette, and preview',
                }}
              />
            }
            label="Use LaTeX"
            style={{ display: 'block', margin: '0 8px' }}
          />
          <LatexEditorFormContext.Provider value={{ useLatex }}>
          <div style={{ margin: 8 }}>
            {hideCardForRepeatPrompt ? (
              <div style={{ margin: '16px 0' }}>
                Use the primary button below to continue with the cards you have
                not solved yet in this session.
              </div>
            ) : (
              test
            )}
            <div>
              remaining:{' '}
              {testStatus.solved === 'open'
                ? testStatus.flashcardTests.length - testStatus.currentTest
                : testStatus.flashcardTests.length - testStatus.currentTest - 1}
              , passed: {testStatus.numPassedTests}, failed:{' '}
              {testStatus.numFailedTests}, skipped: {testStatus.numSkippedTests}
            </div>
            <div>
              achievement:
              {testStatus.achievement +
                calcAchivement(
                  testStatus.flashcardData.header.passlevel,
                  testStatus.oldPasslevel,
                )}
              {' (session) '}
              {possibleAchievement}
              {' (possible) '}
              {' — '}
              {' (today) '}
              {flashcardHeaders.length}
              {' (needed) '}
              days
            </div>

            {showRestartUnsolved ||
            testStatus.currentTest < testStatus.flashcardTests.length ? (
              <div>
                <Button
                  onClick={
                    showRestartUnsolved ? restartWithUnsolved : solve
                  }
                  className={classes.buttonClear}
                  variant="contained"
                  color="primary"
                  size="small"
                  fullWidth
                >
                  {showRestartUnsolved
                    ? `Again: open flashcards (${testStatus.sessionUnsolvedIds.length})`
                    : testStatus.solved !== 'open'
                      ? 'Next'
                      : 'Submit'}
                </Button>
              </div>
            ) : (
              <div></div>
            )}

            {showPrimaryButton && !hideCardForRepeatPrompt ? (
              <>
                <Button
                  onClick={openEditFlashcard}
                  className={classes.buttonClear}
                  variant="contained"
                  color="primary"
                  size="small"
                  fullWidth
                  disabled={
                    testStatus.flashcardData?._id == null ||
                    testStatus.flashcardData?.source === undefined
                  }
                  aria-label="Edit current flashcard"
                >
                  Edit flashcard
                </Button>
                <Button
                  onClick={() => {
                    skip();
                  }}
                  className={classes.buttonClear}
                  variant="contained"
                  color="secondary"
                  size="small"
                  fullWidth
                >
                  {'Skip'}
                </Button>
                <Button
                  onClick={() => setDeleteConfirmOpen(true)}
                  className={classes.buttonClear}
                  variant="contained"
                  color="secondary"
                  size="small"
                  fullWidth
                >
                  Delete card
                </Button>
              </>
            ) : null}
            <Button
              onClick={(e) => {
                close();
              }}
              className={classes.buttonClear}
              variant="contained"
              color="secondary"
              size="small"
              fullWidth
            >
              Close
            </Button>
          </div>
          </LatexEditorFormContext.Provider>
        </Dialog>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Testform;
